import type { ReactElement } from 'react';

export default function RouteError(): ReactElement {
	return <p>Route failed!</p>;
}
